module.exports = __webpack_public_path__ + "static/media/settings.fa197ef6.svg";